import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class AccountStatusService {

  accountsStatus$: BehaviorSubject<any>;

  constructor(private http: HttpClient,
    private snackBar: MatSnackBar) { 
    this.accountsStatus$ = new BehaviorSubject(null);
  }

  loadStatus(accountId:number,versionId:number) {
    
    this.accountsStatus$.next({"loading":true,data:[]});

    let params = new HttpParams()
    .set('accountid', accountId.toString())
    .set('versionid', versionId.toString())

    this.http.get("/api/data/accountstatus",{ params }).subscribe(
      (response: any) => {
        const rtn = response;
        this.accountsStatus$.next({"loading":false,data:rtn});
      }, (error: any) => {
        // window.location.href = "/login"
        console.log('unable to get account');
        console.log(error);
      }
    );
  }


  
  updateStatus(data:object){

    // put on the spinner
    let olddata = this.accountsStatus$.getValue().data;
    this.accountsStatus$.next({"loading":true,data:olddata});

    //
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    this.http.post("/api/data/accountstatus", data, {headers: headers})
    .subscribe(
      (response: any) => {

        if(response.success){
          
          
          // update the data if the id is already there, or add if its not
          // returned as an array with possible multiple values
          let data = this.accountsStatus$.getValue().data;
                    
          response.data.forEach(rtndata => {
            const rtnid = rtndata["id"];
            let found = false;
            data.forEach((x,i) => {
              if(x["id"]==rtnid){
                found = true;
                data[i] = rtndata;
              }
            });
  
            if(!found) data.push(rtndata);          
          });

          // publish the new data
          // console.log(data)
          this.accountsStatus$.next({"loading":false,data:data});

        }

        // this.entities$.next(response);
        //console.log(response);
      }, (error: any) => {
        let message="Unable to update the Account Status"
        let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
        console.log(message + " > " + JSON.stringify(error));

        setTimeout(() => {
          document.location.reload();
        },1000)

      }
    );

  }

  deleteEvent(data:object){

    // put on the spinner
    let olddata = this.accountsStatus$.getValue().data;
    this.accountsStatus$.next({"loading":true,data:olddata});

    //
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options = {
      headers:headers,
      body: data
    }
    const deletedata =data;

    this.http.delete("/api/data/accountstatus", options)
    .subscribe(
      (response: any) => {

        if(response.success){        
          
          // update the data if the id is already there, or add if its not
          // returned as an array with possible multiple values
          let data = this.accountsStatus$.getValue().data;
          
          if(options.body instanceof Array){
            var deleteIndexs = [];
            options.body.forEach(rtndata => {
              const rtnid = rtndata["id"];
              data.forEach((x,i) => {
                if(x["id"]==rtnid){
                  deleteIndexs.push(i);
                }
              });
             
            });           
            deleteIndexs.sort(function(a, b) { return b - a});
            deleteIndexs.forEach(function(index) { data.splice(index, 1) })
          }

          // publish the new data
          // console.log(data)
          this.accountsStatus$.next({"loading":false,data:data});

        }

        // this.entities$.next(response);
        //console.log(response);
      }, (error: any) => {
        let message="Unable to update the Account Status"
        let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
        console.log(message + " > " + JSON.stringify(error));

        setTimeout(() => {
          document.location.reload();
        },1000)

      }
    );

  }

}
